import { stringify } from 'query-string';
import { useHistory } from 'react-router';

import useUrlQuery from '@dashboard/hooks/useUrlQuery';

export type EmailTemplatesMode = 'templates' | 'pages';
export type PreviewWidth = 'desktop' | 'mobile';

const PARAMS = [
  'mode',
  'template',
  'preview',
  'width',
  'q',
  'page',
  'price',
  'email',
  'charge',
] as const;

type UrlParams = Record<(typeof PARAMS)[number], string>;

// useUrlQuery turns "true" or "1234" into a boolean or number, and IDs must stay strings.
const readParam = (value: unknown) => (value == null ? '' : String(value));

export default function useEmailTemplatesUrl() {
  const history = useHistory();
  const query = useUrlQuery();

  const params = Object.fromEntries(
    PARAMS.map(name => [name, readParam(query[name])]),
  ) as UrlParams;

  const mode: EmailTemplatesMode = params.mode === 'pages' ? 'pages' : 'templates';
  const width: PreviewWidth = params.width === 'mobile' ? 'mobile' : 'desktop';

  const update = (changes: Partial<UrlParams>) => {
    const next = { ...params, ...changes };
    history.replace({
      search: stringify(
        {
          ...next,
          mode: next.mode === 'pages' ? 'pages' : '',
          width: next.width === 'mobile' ? 'mobile' : '',
        },
        { skipEmptyString: true, sort: false },
      ),
    });
  };

  return { ...params, mode, width, update };
}
